var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFinal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 599.26 541.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre",
    "data-name": "Degradado sin nombre",
    x1: -413.06,
    y1: 827.96,
    x2: -413.06,
    y2: 627.96,
    gradientTransform: "translate(1154.62 1726.14) scale(2.09 -2.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5515f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f041b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "501.6 416.28 293.01 416.28 293.01 406.1 491.42 406.1 491.42 9.28 94.59 9.28 94.59 207.69 84.42 207.69 84.42 -.9 501.6 -.9 501.6 416.28",
    fill: "url(#Degradado_sin_nombre)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "text-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.09,533.28h6.72v-24.98h6.72l12.01,24.98h7.2l-12.3-25.74c5.67-1.44,9.41-5.38,9.41-14.6v-11.53c0-12.87-7.2-15.37-16.33-15.37H-.09v67.24ZM6.63,502.54v-30.74h6.72c5.86,0,9.61,1.83,9.61,10.57v9.61c0,8.74-3.75,10.57-9.61,10.57h-6.72ZM79.45,466.04v67.24h28.82v-5.76h-22.09v-24.98h16.33v-5.76h-16.33v-24.98h21.13v-5.76h-27.86ZM170.51,466.04h-14.41v67.24h14.41c9.13,0,16.33-2.69,16.33-15.37v-36.5c0-12.87-7.2-15.37-16.33-15.37ZM162.82,471.81h7.68c5.86,0,9.61,1.83,9.61,10.57v34.58c0,8.74-3.75,10.57-9.61,10.57h-7.68v-55.71ZM252.45,534.24c9.03,0,16.33-2.5,16.33-15.37v-1.92c0-15.47-25.94-25.36-25.94-34.58,0-8.74,3.75-10.57,9.61-10.57s9.61,1.83,9.61,10.57v3.84h6.72v-5.76c0-12.87-7.2-15.37-16.33-15.37s-16.33,2.5-16.33,15.37v1.92c0,13.83,25.94,23.73,25.94,34.58,0,8.74-3.75,10.57-9.61,10.57s-9.61-1.83-9.61-10.57v-5h-6.72v6.92c0,12.68,7.2,15.37,16.33,15.37ZM361.57,466.04h-9.61l-11.43,41.11-11.43-41.11h-9.61v67.24h6.72v-53.41l10.85,39h6.92l10.85-39v53.41h6.72v-67.24ZM408.44,533.28h6.72l3.84-18.25h17.19l3.84,18.25h6.72l-14.12-67.24h-10.09l-14.12,67.24ZM420.26,509.27l7.4-35.25,7.4,35.25h-14.79ZM493.65,533.28h6.72v-24.98h6.72l12.01,24.98h7.2l-12.3-25.74c5.67-1.44,9.41-5.38,9.41-14.6v-11.53c0-12.87-7.2-15.37-16.33-15.37h-13.45v67.24ZM500.37,502.54v-30.74h6.72c5.86,0,9.61,1.83,9.61,10.57v9.61c0,8.74-3.75,10.57-9.61,10.57h-6.72ZM598.16,466.04h-31.7v5.76h12.49v61.48h6.72v-61.48h12.49v-5.76Z",
    fill: "#ff5758"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "tagline-3a78d944-c0db-44d4-8ad5-60158c925687-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tagline-3a78d944-c0db-44d4-8ad5-60158c925687-logo-path-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.49,276.23h12.78v-47.45h12.78l22.8,47.45h13.7l-23.36-48.91c10.76-2.75,17.89-10.22,17.89-27.74v-21.9c0-24.46-13.7-29.2-31.03-29.2h-25.55v127.76ZM280.27,217.82v-58.4h12.78c11.12,0,18.25,3.48,18.25,20.08v18.25c0,16.62-7.13,20.08-18.25,20.08h-12.78Z",
    fill: "#ff5758"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFinal);
export default __webpack_public_path__ + "static/media/logo-final.94e4f60c0d359981b3d40eb1c7efedce.svg";
export { ForwardRef as ReactComponent };